import { Navigate } from "react-router-dom";
// hooks
import { PropsWithChildren, ReactElement } from "react";
import useAuth from "@convin/hooks/useAuth";
import { DashboardRoutesConfig } from "@convin/config/routes.config";

const conversationRoute = DashboardRoutesConfig.Conversations;

// const homeRoute = DashboardRoutesConfig.Home;

export default function GuestGuard({
    children,
}: PropsWithChildren): ReactElement {
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        return <Navigate to={conversationRoute.to} />;
    }

    return <>{children}</>;
}
